import type {
  ClientMediaItem,
  ClientPerson
} from '@DigitaleDoerfer/digitale-doerfer-api';

import { CheckIcon, PersonIcon } from '@/assets';
import { OrganizationLogo } from '@/features/media/components/avatar/OrganizationLogo';
import { ProfileAvatar } from '@/features/media/components/avatar/ProfileAvatar';
import { MediaItemSize } from '@/features/media/types/mediaItem';
import {
  getPersonAvatarPicture,
  getPersonAvatarTextFallback
} from '@/features/media/utils/person';
import type { SVGComponent } from '@/types';

const AVATAR_SIZE = 40;

export const personAvatarIcon = (person?: ClientPerson): SVGComponent => {
  const PersonAvatarIcon: SVGComponent = () => (
    <ProfileAvatar
      viewSize={AVATAR_SIZE}
      iconFallback={PersonIcon}
      mediaItem={person ? getPersonAvatarPicture(person) : undefined}
      textFallback={person ? getPersonAvatarTextFallback(person) : undefined}
      mediaSize={MediaItemSize.SMALL}
    />
  );
  return PersonAvatarIcon;
};

export const largeOrganizationLogoIcon = (
  mediaItem?: ClientMediaItem
): SVGComponent => {
  const LogoIcon: SVGComponent = () => (
    <OrganizationLogo mediaItem={mediaItem} size={AVATAR_SIZE} />
  );
  return LogoIcon;
};

export const selectedIcon = (selected: boolean) =>
  selected ? { arrowIcon: CheckIcon } : { hideRightArrow: true };
